"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        return [_c("section", {
          staticClass: "create-lot-page"
        }, [_c("form", {
          on: {
            submit: function submit($event) {
              $event.preventDefault();
              return _vm.submitForm.apply(null, arguments);
            }
          }
        }, [_c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Tipo e data do lote\n          ")]), _vm._v(" "), _c("div", {
          staticClass: "form-row"
        }, [_c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Tipo do lote"
          }
        }, [_c("b-select", {
          attrs: {
            placeholder: "Selecione o tipo",
            expanded: "",
            required: ""
          },
          model: {
            value: _vm.form.type,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "type", $$v);
            },
            expression: "form.type"
          }
        }, [_c("option", {
          attrs: {
            disabled: ""
          },
          domProps: {
            value: null
          }
        }, [_vm._v("\n                  Selecione o tipo\n                ")]), _vm._v(" "), _vm._l(_vm.lotTypeOptions, function (option) {
          return _c("option", {
            key: option.value,
            domProps: {
              value: option.value
            }
          }, [_vm._v("\n                  " + _vm._s(option.label) + "\n                ")]);
        })], 2)], 1), _vm._v(" "), _c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Data"
          }
        }, [_c("b-datepicker", {
          attrs: {
            placeholder: "Selecione a data",
            icon: "calendar-today",
            expanded: "",
            required: ""
          },
          model: {
            value: _vm.form.date,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "date", $$v);
            },
            expression: "form.date"
          }
        })], 1)], 1), _vm._v(" "), _c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Selecione a variedade\n          ")]), _vm._v(" "), _c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: _vm.varietyFieldLabel
          }
        }, [_c("b-select", {
          attrs: {
            placeholder: "Selecione a variedade",
            expanded: "",
            required: ""
          },
          model: {
            value: _vm.form.varietyId,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "varietyId", $$v);
            },
            expression: "form.varietyId"
          }
        }, [_c("option", {
          attrs: {
            disabled: ""
          },
          domProps: {
            value: null
          }
        }, [_vm._v("\n                Selecione a variedade\n              ")]), _vm._v(" "), _vm._l(_vm.varietyOptions, function (variety) {
          return _c("option", {
            key: variety.id,
            domProps: {
              value: variety.id
            }
          }, [_vm._v("\n                " + _vm._s(variety.name) + "\n              ")]);
        })], 2)], 1), _vm._v(" "), _c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Defina os locais e quantidades\n          ")]), _vm._v(" "), _c("SectionRowInventories", {
          attrs: {
            "show-quantity": true,
            label: "",
            "item-title": "Local",
            "add-button-label": "Adicionar local",
            "add-first-label": "Adicionar primeiro local",
            "empty-message": "Nenhum local adicionado.",
            "min-items": 1,
            "max-items": 10
          },
          model: {
            value: _vm.form.inventories,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "inventories", $$v);
            },
            expression: "form.inventories"
          }
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "form-actions"
        }, [_c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            type: "is-primary",
            "native-type": "submit",
            loading: _vm.isSubmitting,
            disabled: _vm.isSubmitting
          }
        }, [_vm._v("\n            Criar lote\n          ")]), _vm._v(" "), _c("b-button", {
          attrs: {
            type: "is-text",
            disabled: _vm.isSubmitting
          },
          on: {
            click: _vm.handleCancel
          }
        }, [_vm._v("\n            Cancelar\n          ")])], 1)])])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;